export const CategoryAttributeEnum = {
  LocalDicount: 1,
  ImportedDicount: 2,
};

export const CategoryAttributeName = {
  [CategoryAttributeEnum.LocalDicount]: 'Local',
  [CategoryAttributeEnum.ImportedDicount]: 'Imported',
};
